import React from 'react';
import AnswerKeyHeader from './AnswerKeyHeader';

const AnswerKeyErrorIdentification = ({ lesson, data, dir }) => {
  const align = dir === 'rtl' ? 'right' : 'left';
  const styles = {
    response: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'left',
      width: '100%',
      marginBottom: '0.25in',
      paddingLeft: '0.5in',
      paddingRight: '0.5in'
    },
    responselabel: {
      textAlign: 'left',
      fontSize: '10pt',
      color: '#666',
      marginBottom: '0.125in'
    },
    responsecontent: {
      fontSize: dir === 'rtl' ? '14pt' : '12pt',
      textAlign: align,
      unicodeBidi: 'isolate'
    }
  };

  return data.content.core.map((question, index) => {
    // console log the first question to understand the structure of the data
    if (index === 0) {
      console.log('Question Data:', question);
    }

    const baseTranscript = question.authentic_transcript_correct || '';
    const lures = question.lures || [];

    let lureIndex = 0;
    const incorrectTranscriptHtml = baseTranscript
      // swap green highlighted correct words with incorrect lure words, underlined
      .replace(
        /<span[^>]*background-color:\s*rgb\(97,\s*189,\s*109\)[^>]*>.*?<\/span>/gi,
        () => {
          const replacement = lures[lureIndex]?.error || '';
          lureIndex += 1;
          return `<u>${replacement}</u>`;
        }
      )
      // turn any remaining highlighted spans into underlined text
      .replace(/<span[^>]*>(.*?)<\/span>/gi, '<u>$1</u>');

    lureIndex = 0; // reset lure index for correct transcript
    const correctTranscriptHtml = baseTranscript
      // GREEN → keep same green + underline
      .replace(
        /<span[^>]*background-color:\s*rgb\(97,\s*189,\s*109\)[^>]*>(.*?)<\/span>/gi,
        '<u style="background-color: rgb(97,189,109);">$1</u>'
      )
      // others → underline only
      .replace(/<span[^>]*>(.*?)<\/span>/gi, '<u>$1</u>');

    return (
      <div
        key={data.screen + '_' + index}
        className="page"
        style={{
          width: '8.5in',
          minHeight: '11in',
          padding: '0.5in',
          boxSizing: 'border-box',
          margin: '0 auto',
          border: '1px #D3D3D3 solid',
          borderRadius: '4px',
          background: 'white',
          pageBreakAfter: 'always',
          color: '#333'
        }}
      >
        <AnswerKeyHeader lesson={lesson} page={data} questionNum={index + 1} />
        <div style={styles.response}>
          <p style={styles.responselabel}>Question {index + 1}:</p>
          <p
            style={styles.responsecontent}
            dangerouslySetInnerHTML={{ __html: incorrectTranscriptHtml }}
          />
        </div>
        <div style={styles.response}>
          <p style={styles.responselabel}>Correct Response:</p>
          <p
            style={styles.responsecontent}
            dangerouslySetInnerHTML={{ __html: correctTranscriptHtml }}
          />
        </div>
      </div>
    );
  });
};

export default AnswerKeyErrorIdentification;
